import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common'; // Importa CommonModule
@Component({
  selector: 'app-loading-overlay',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './loading-overlay.component.html',
  styleUrl: './loading-overlay.component.scss'
})
export class LoadingOverlayComponent {
  @Input() visible: boolean = false;
  @Input() title: string = 'Elaborazione in corso...';
  @Input() message: string = 'Attendi qualche secondo. Ci siamo quasi!';
}
